import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { CalendarService } from '../services/calendar-service/calendar.service';

import { MatSidenav } from '@angular/material/sidenav';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mcrit-gestio-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [CalendarService]
})
export class DashboardComponent implements OnInit {
  public isOpen: boolean[] = new Array(11).fill(true); // tots oberts per defecte

  constructor(public translate: TranslateService, public languageService: LanguageService, private calendarService: CalendarService) { }

  ngOnInit() { }

  ngOnDestroy(): void { }

}
